// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { PopupForm } from './popup-form';
import { Tree } from './file-manager/tree';

/**
 * @class Jsw.DirectoryBrowser
 * @extends Jsw.PopupForm
 */
export const DirectoryBrowser = Class.create(PopupForm, {
    _initConfiguration($super, config) {
        $super(config);
        this._pathElementId = this._getConfigParam('pathElementId');
        this._subscriptionId = this._getConfigParam('subscriptionId');
        this._showFiles = this._getConfigParam('showFiles', false);
        this._onSubmit = this._getConfigParam('onSubmit', () => {});
    },

    render($super) {
        $super();

        this.setBoxType('form-box');
        this.setTitle(this.lmsg('title'));

        $(this._contentAreaId).update(
            `<form method="post" id="${this._id}-form">` +
                '<div class="single-row">' +
                '<div class="scrollable fm-scrollable" style="height: 300px;">' +
                '<div class="scrollable-wrap">' +
                `<div id="${this._id}-files-tree" class="tree"></div>` +
                '</div>' +
                '</div>' +
                '</div>' +
            '</form>'
        );

        this._tree = new Tree(Object.extend({
            applyTo: `${this._id}-files-tree`,
            data: null,
            dataUrl: `^/smb/file-manager/tree-data/subscriptionId/${this._subscriptionId}`,
            showFiles: this._showFiles,
            onNodeClick: this._onTreeNodeClick.bind(this),
            onReload() {
                this.setDirectory('/');
            },
        }, this._getConfigParam('treeConfig', {})));

        this._buttonOk = this.addRightButton(this.lmsg('buttonOk'), this._onOkClick, true, true);
        this._buttonCancel = this.addRightButton(this.lmsg('buttonCancel'), this._onCancelClick, false, false);

        if (this._showFiles) {
            this._updateButton(this._buttonOk, { disabled: true });
        }
    },

    _onTreeNodeClick() {
        this._updateButton(this._buttonOk, { disabled: this._showFiles && this._tree.getSelectedItemData().isDirectory });
    },

    _onOkClick(event) {
        if (event) {
            event.preventDefault();
        }

        const selectedPath = this._tree.getSelectedItemData().path;
        const pathValue = this._showFiles ? selectedPath.substr(1) : selectedPath;
        if (this._pathElementId) {
            $(this._pathElementId).value = pathValue;
        }
        this._onSubmit(pathValue);
        this.hide();
    },

    _onCancelClick() {
        this.hide();
    },
});



// WEBPACK FOOTER //
// ./jsw/directory-browser.js